import React from 'react';
import { Text } from '@atlaskit/primitives/compiled';
import { Box } from '@atlaskit/primitives';
import SectionMessage from '@atlaskit/section-message';
import { useIntl } from '@atlassian/jira-intl';
import { createObjectTypeUrl } from '@atlassian/jira-servicedesk-insight-urls/src/index.tsx';
import type { ObjectTypeGraphNode } from '../../common/types.tsx';
import { SidebarHeader } from '../../common/ui/sidebar-header/index.tsx';
import messages from './messages.tsx';

type Props = {
	objectTypeNode: ObjectTypeGraphNode;
};

export const ObjectTypeView = (props: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();

	const { objectTypeNode } = props;
	const { name, icon, objectSchemaId, referenceId } = objectTypeNode;

	return (
		<Box padding="space.200">
			<SidebarHeader
				title={name}
				iconUrl={icon}
				tooltip={formatMessage(messages.openObjectTypeDetails)}
				link={createObjectTypeUrl(objectSchemaId, referenceId)}
			/>
			<SectionMessage appearance="information">
				<Text as="p">{formatMessage(messages.maxOfTypeExceeded)}</Text>
			</SectionMessage>
		</Box>
	);
};
